import { DeleteOutlined, EyeOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Drawer, Image, Input, message } from 'antd';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { uploadFileFromObject } from '../../api/common/image-upload.js';

import { getPreviewUrl } from '../../library/constants/urls.js';
import { AddFileUpload } from '../../ui/addFileUpload.jsx';
import styles from './file-manager.module.scss';
import { showAlert } from '../message/alert.jsx';
const { TextArea } = Input;

const FileManager = ({ title = "", files = [], acceptedFileTypes = null, isOpen = false, project_id, item_id, actionButtonText = "Upload", onUpload, onDelete, onClose, width = 'min(92vw, 560px)', ...otherProps }) => {
    const [previewFileUrl, setPreviewFileUrl] = useState(null)
    // const [isDeleting, setIsDeleting] = useState(null)
    const [isUploading, setIsUploading] = useState(false)
    const fileUploaderRef = useRef([])

    const handleFileUpload = async () => {
        if (fileUploaderRef.current.length === 0) {
            showAlert('Please select atleast one file')
            return
        }
        setIsUploading(true)
        const promises = fileUploaderRef.current.map(({ file }) => uploadFileFromObject(file))
        try {
            const fileIds = await Promise.all(promises)
            const imageData = fileIds.map((id, index) => ({
                id,
                comment: fileUploaderRef.current[index].comment
            }))
            onUpload(imageData)
            fileUploaderRef.current = []
        }
        catch (error) {
            message.error('Unable to upload files')
        }
        setIsUploading(false)
    }

    // const handleDeleteFile = async (url) => {
    //     setIsDeleting(url)
    //     try {
    //         const msg = await deleteImage(projectId, url)
    //         message.success(msg)
    //         revalidator.revalidate()
    //     }
    //     catch (error) {
    //         message.error(error.message)
    //     }
    //     setIsDeleting(null)
    // }

    return (
        <Drawer placement='right' width={width} title={title} open={isOpen} onClose={onClose} footer={
            <div className="actions align--right file-manager-actions">
                <Button onClick={() => handleFileUpload()} icon={<UploadOutlined />} type="primary" loading={isUploading}>{actionButtonText}</Button>
                <Button onClick={onClose} danger disabled={isUploading}>Close</Button>
            </div>
        } {...otherProps}>
            {!!files && files.length > 0 && (
                <div className={`${styles.files} ${isUploading && styles.isUploading}`}>
                    {files.map(file => (
                        <div className={styles.file} key={file.url}>
                            <div style={{ width: "32%", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <img src={getPreviewUrl(file.url, project_id, item_id)} />
                                <p className={styles.label}>{file.name}</p>
                            </div>
                            <div style={{ 'width': '32%' }}>
                                <TextArea label="Add a comment" value={file.comment} disabled maxLength={250}/>
                            </div>
                            <div style={{ 'width': '20%' }}>
                                {onDelete && <Button onClick={() => { onDelete(file.url) }} icon={<DeleteOutlined />} >Delete</Button>}
                                <Button onClick={() => { setPreviewFileUrl(file.url) }} icon={<EyeOutlined />}>View</Button>
                                <Image
                                    width={200}
                                    style={{
                                        display: 'none',
                                    }}
                                    src={file.url}
                                    preview={{
                                        visible: previewFileUrl === file.url,
                                        src: file.url,
                                        onVisibleChange: (value) => {
                                            setPreviewFileUrl(value ? file.url : null);
                                        },
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            )}
            <AddFileUpload ref={fileUploaderRef} acceptedFileTypes={acceptedFileTypes} />
        </Drawer>
    )
}
FileManager.propTypes = {
    title: PropTypes.string,
    files: PropTypes.arrayOf(PropTypes.shape({
        url: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        comment: PropTypes.string,
    })),
    acceptedFileTypes: PropTypes.arrayOf(PropTypes.string),
    isOpen: PropTypes.bool.isRequired,
    actionButtonText: PropTypes.string,
    onUpload: PropTypes.func.isRequired,
    onDelete: PropTypes.func,
    onClose: PropTypes.func.isRequired,
    project_id: PropTypes.number,
    item_id: PropTypes.number,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default FileManager
